import {compareLocaleStrings} from '@/utilities/locales'

interface TaxonomyOption {
	readonly text: string
	readonly value: string
}

const TAXONOMY_TERM_ORDER: Partial<Record<string, string[][]>> = {
	jp: [
		[
			'parasiticides',
			'heart',
			'kidney',
			'skin',
			'oa_pain',
			'anti_bio',
			'nutrition',
			'others',
		],
		[
			'_vaccine_',
			'antibacterial_agent_',
			'parasite_control_agents_',
			'_parasite_control_agents_',
			'environmental_hygiene_products_',
			'mixed_feed_',
			'feed_additives_',
			'others_',
		],
	],
}

export function sortTaxonomyOptions(
	options: readonly TaxonomyOption[],
	locale: string | undefined
): TaxonomyOption[] {
	const configuredOrder = TAXONOMY_TERM_ORDER[locale ?? '']?.find((order) =>
		order.some((codename) =>
			options.some((option) => option.value === codename)
		)
	)

	if (!configuredOrder) {
		return options.toSorted((a, b) =>
			compareLocaleStrings(a.text, b.text, locale)
		)
	}

	const configuredOrderIndex = new Map(
		configuredOrder.map((codename, index) => [codename, index])
	)

	return options.toSorted((a, b) => {
		const aIndex = configuredOrderIndex.get(a.value)
		const bIndex = configuredOrderIndex.get(b.value)

		if (aIndex !== undefined && bIndex !== undefined) {
			return aIndex - bIndex
		}

		if (aIndex !== undefined) return -1
		if (bIndex !== undefined) return 1

		return compareLocaleStrings(a.text, b.text, locale)
	})
}
